import Navbar from 'components/Home/Navbar'
import Footer from 'components/Home/Footer'
import { DrawerProvider } from 'components/Home/DrawerContext';
import Sticky from 'react-stickynode'
import styles from './style.module.css'
import { saasTheme } from 'components/Home/saasTheme';
import { GlobalStyle, ContentWrapper } from 'components/Home/saasStyle';
import { ThemeProvider } from 'styled-components';
import ResetCSS from 'components/Home/resetCSS';

export default function WordpressLayout({ children }) {
    return (
        <ThemeProvider theme={saasTheme}>
                    <ResetCSS />
            <GlobalStyle />
            <div>
                <ContentWrapper>
                <div className={`about-page ${styles.navContainer}`}>        
                        <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
                            <DrawerProvider>
                                <Navbar />
                            </DrawerProvider>
                        </Sticky>
                    </div>
                </ContentWrapper>
                {children}
                <Footer about />
            </div>
        </ThemeProvider>
    )    
}